<script setup lang="ts">
import { ref } from "vue";
import { type DRPartialProject, type Project } from "@/types/projects.types";
import DRColorPicker from "../UI/form/DRColorPicker.vue";
import ProjectAvatar from "./ProjectAvatar.vue";
import { useUpdateProject } from "@/stores/queries";

const props = withDefaults(
  defineProps<{
    project: Project | DRPartialProject;
    readonly?: boolean;
    size?: number;
  }>(),
  {
    readonly: false,
    size: 44,
  }
);

const { mutateAsync: mutateUpdateProject } = useUpdateProject();

const data = ref(props.project.color);

const updateColor = (color: string) => {
  data.value = color;
  mutateUpdateProject({
    id: props.project.id,
    color,
  });
};
</script>

<template>
  <DRColorPicker
    v-if="!readonly"
    :model-value="data"
    @update:model-value="updateColor"
  >
    <div class="pb-2 fw-medium">Modifier la couleur</div>

    <template #reference="{ currentColor }">
      <ProjectAvatar
        class="cursor-pointer"
        :project="{ color: currentColor }"
        :size="size"
      ></ProjectAvatar>
    </template>
  </DRColorPicker>

  <ProjectAvatar v-else :project="project" :size="size" />
</template>

<style lang="scss" scoped></style>
